// Romanian locale data: skills and testimonials (same structure as home.ts)

export const isotopeItems = [
	{
		name: "C#",
		background_url: "/assets/vendors/skills/c-sharp-logo.webp",
		category: "programing_lang",
		link: "https://docs.microsoft.com/en-us/dotnet/csharp/",
		description:
			"C# este un limbaj de programare modern, orientat pe obiecte, dezvoltat de Microsoft.",
	},
	{
		name: ".NET Framework",
		background_url: "/assets/vendors/skills/microsoft-net-framework-logo.webp",
		category: "programing_lang",
		link: "https://dotnet.microsoft.com/download/dotnet-framework",
		description:
			".NET Framework este un framework software dezvoltat de Microsoft care rulează în principal pe Microsoft Windows.",
	},
	{
		name: "JavaScript",
		background_url: "/assets/vendors/skills/javascript-js-logo.webp",
		category: "programing_lang web_development",
		link: "https://www.javascript.com/",
		description:
			"JavaScript este unul dintre cele mai puternice limbaje de programare pentru web, putând comportamentul dinamic pe majoritatea site-urilor.",
	},
	{
		name: "PHP",
		background_url: "/assets/vendors/skills/php-logo.webp",
		category: "programing_lang web_development",
		link: "https://www.php.net/",
		description:
			"PHP este un limbaj de scripting pentru server și un instrument puternic pentru pagini web dinamice și interactive.",
	},
	{
		name: "Sharepoint",
		background_url: "/assets/vendors/skills/microsoft-sharepoint-logo.webp",
		category: "programing_lang web_development",
		link: "https://www.microsoft.com/en-us/microsoft-365/sharepoint/collaboration",
		description:
			"SharePoint este o platformă colaborativă web care se integrează cu Microsoft Office, pentru managementul documentelor.",
	},
	{
		name: "Node JS",
		background_url: "/assets/vendors/skills/nodejs-logo.webp",
		category: "programing_lang",
		link: "https://nodejs.org/en/",
		description:
			"Node.js este un mediu runtime JavaScript open-source care execută cod JavaScript în afara browserului.",
	},
	{
		name: "HTML",
		background_url: "/assets/vendors/skills/html5-logo.webp",
		category: "web_development",
		link: "https://www.w3schools.com/html/",
		description:
			"HTML este limbajul standard de marcare pentru documente afișate într-un browser web.",
	},
	{
		name: "CSS",
		background_url: "/assets/vendors/skills/css-3-logo.webp",
		category: "web_development",
		link: "https://www.w3schools.com/css/",
		description:
			"CSS este limbajul pentru stilizarea prezentării documentelor scrise în HTML sau alte limbaje de marcare.",
	},
	{
		name: "jQuery",
		background_url: "/assets/vendors/skills/jquery-logo.webp",
		category: "web_development",
		link: "https://jquery.com/",
		description:
			"jQuery este o bibliotecă JavaScript pentru traversarea DOM, manipulare, evenimente și Ajax.",
	},
	{
		name: "Bootstrap",
		background_url: "/assets/vendors/skills/bootstrap-logo.webp",
		category: "web_development",
		link: "https://getbootstrap.com/",
		description:
			"Bootstrap este un framework CSS open-source pentru dezvoltare front-end responsive, mobile-first.",
	},
	{
		name: "AngularJS",
		background_url: "/assets/vendors/skills/angular-logo.webp",
		category: "programing_lang web_development",
		link: "https://angularjs.org/",
		description:
			"AngularJS este un framework front-end open-source bazat pe JavaScript pentru aplicații single-page.",
	},
	{
		name: "Microsoft SQL Server",
		background_url: "/assets/vendors/skills/microsoft-sql-server-logo.webp",
		category: "databases",
		link: "https://www.microsoft.com/en-us/sql-server",
		description:
			"Microsoft SQL Server este un sistem de management al bazelor de date relaționale.",
	},
	{
		name: "PostgreSQL",
		background_url: "/assets/vendors/skills/postgresql-logo.webp",
		category: "databases",
		link: "https://www.postgresql.org/",
		description:
			"PostgreSQL este un sistem de management al bazelor de date relaționale, open-source, extensibil și conform SQL.",
	},
	{
		name: "NestJS",
		background_url: "/assets/vendors/skills/nestjs-logo.webp",
		category: "programing",
		link: "https://nestjs.com/",
		description:
			"Framework Node.js progresiv pentru aplicații server-side eficiente, fiabile și scalabile.",
	},
	{
		name: "MySQL",
		background_url: "/assets/vendors/skills/MySQL-logo.webp",
		category: "databases",
		link: "https://www.mysql.com/",
		description:
			"MySQL este un serviciu de bază de date pentru aplicații cloud-native, cea mai populară bază open-source.",
	},
	{
		name: "Redis",
		background_url: "/assets/vendors/skills/redis-logo.webp",
		category: "databases",
		link: "https://redis.io/",
		description:
			"Redis este o bază de date în memorie, tip cheie-valoare, distribuită, cu durabilitate opțională.",
	},
	{
		name: "Oracle",
		background_url: "/assets/vendors/skills/oracle-logo.webp",
		category: "databases",
		link: "https://www.oracle.com/database/",
		description:
			"Oracle Database este un sistem de management al bazelor de date pentru OLTP, data warehousing și sarcini mixte.",
	},
	{
		name: "Azure",
		background_url: "/assets/vendors/skills/microsoft-azure-logo.webp",
		category: "cloud_reporting",
		link: "https://azure.microsoft.com/en-us/",
		description:
			"Microsoft Azure este un serviciu de cloud computing pentru construirea, testarea și gestionarea aplicațiilor.",
	},
	{
		name: "AWS",
		background_url: "/assets/vendors/skills/amazon-web-services-aws-logo.webp",
		category: "cloud_reporting",
		link: "https://aws.amazon.com/",
		description:
			"Amazon Web Services oferă platforme de cloud computing on-demand și API-uri pentru persoane și companii.",
	},
	{
		name: "Heroku",
		background_url: "/assets/vendors/skills/heroku-logo.webp",
		category: "cloud_reporting",
		link: "https://www.heroku.com/",
		description:
			"Heroku este o platformă cloud PaaS care suportă mai multe limbaje de programare.",
	},
	{
		name: "SQL Server Analysis Services",
		background_url: "/assets/vendors/skills/microsoft-sql-server-logo.webp",
		category: "cloud_reporting",
		link: "https://docs.microsoft.com/en-us/analysis-services/instances/install-windows/install-analysis-services?view=asallproducts-allversions",
		description:
			"SSAS este un instrument de procesare analitică și data mining în Microsoft SQL Server.",
	},
	{
		name: "Power BI",
		background_url: "/assets/vendors/skills/power-bi-microsoft-logo.webp",
		category: "cloud_reporting",
		link: "https://powerbi.microsoft.com/en-us/",
		description:
			"Power BI este un serviciu de analiză de business de la Microsoft cu vizualizări interactive și raportare.",
	},
	{
		name: "DevExpress",
		background_url: "/assets/vendors/skills/devexpress-logo.webp",
		category: "cloud_reporting",
		link: "https://www.devexpress.com/",
		description:
			"DevExpress oferă controale UI, instrumente și framework-uri pentru WinForms, ASP.NET, WPF, Blazor și altele.",
	},
	{
		name: "Git",
		background_url: "/assets/vendors/skills/git-logo.webp",
		category: "other",
		link: "https://git-scm.com/",
		description:
			"Git este un sistem de control al versiunilor distribuit pentru urmărirea modificărilor în codul sursă.",
	},
	{
		name: "JSON",
		background_url: "/assets/vendors/skills/json-logo.webp",
		category: "other",
		link: "https://www.json.org/json-en.html",
		description:
			"JSON este un format ușor de schimbat date, ușor de citit și de generat de mașini.",
	},
	{
		name: "XML",
		background_url: "/assets/vendors/skills/xml-logo.webp",
		category: "other",
		link: "https://developer.mozilla.org/en-us/docs/Web/XML/XML_introduction",
		description:
			"XML este un limbaj de marcare care definește reguli pentru codarea documentelor într-un format lizibil.",
	},
	{
		name: "Agile",
		background_url: "/assets/vendors/skills/agile-frameworks-logo.webp",
		category: "other",
		link: "https://www.agilealliance.org/agile101/",
		description:
			"Agile este o abordare iterativă pentru managementul proiectelor și dezvoltarea software care ajută echipele să livreze valoare rapid.",
	},
	{
		name: "Solidity",
		background_url: "/assets/vendors/skills/solidity-logo.webp",
		category: "programing_lang",
		link: "https://docs.soliditylang.org/en/v0.8.10/",
		description:
			"Solidity este un limbaj de nivel înalt pentru contracte inteligente, care guvernează comportamentul conturilor în Ethereum.",
	},
	{
		name: "Salesforce",
		background_url: "/assets/vendors/skills/salesforce-logo.webp",
		category: "other",
		link: "https://www.salesforce.com/",
		description:
			"Salesforce oferă servicii de management al relațiilor cu clienții și aplicații enterprise.",
	},
	{
		name: "RabbitMQ",
		background_url: "/assets/vendors/skills/rabbitmq-logo.png",
		category: "other",
		link: "https://www.rabbitmq.com/",
		description:
			"RabbitMQ este un message broker – intermediar pentru mesaje între aplicații, oferind rutare și livrare flexibilă.",
	},
	{
		name: "Docker",
		background_url: "/assets/vendors/skills/docker-logo.png",
		category: "other",
		link: "https://www.docker.com/",
		description:
			"Docker este o platformă software pentru construirea, testarea și implementarea aplicațiilor în containere.",
	},
	{
		name: "Kubernetes",
		background_url: "/assets/vendors/skills/kubernetes-logo.png",
		category: "other",
		link: "https://kubernetes.io/",
		description:
			"Kubernetes este un sistem open-source pentru automatizarea deploy-ului, scalării și gestionării aplicațiilor în containere.",
	},
];

export const testimonyItems = [
	{
		id: 0,
		company_url: "https://privatbank.ua/",
		company_name: "PrivatBank",
		past_company_name: "Stefanini EMEA",
		worked_with: "Dragos",
		name: "Razvan Tapu",
		job: "Chief Technology Officer",
		paragraph: `Când ne-am întâlnit, eram la începutul carierelor noastre în companie, fiecare adaptându-se rolului nou. Ca Applications Delivery Manager, Dragos făcea parte din echipa mea, de peste 50 de persoane. Am lucrat împreună în companie, apoi el a plecat la client pe termen lung. Am rămas în contact prin întâlniri regulate și am urmărit progresul, relația cu clientul și livrarea conform standardelor. A arătat spirit și dorință de a se adapta la echipe și provocări noi. Am văzut cum și-a dezvoltat abilitățile tehnice și de business, făcând discuțiile din ce în ce mai interesante.`,
		avatar: "/assets/linkedin/razvan_tapu.jpg",
	},
	{
		id: 1,
		company_url: "https://www.honeywell.com",
		company_name: "Honeywell",
		past_company_name: "Garrett Motion",
		worked_with: "Paul",
		name: "Cristina Deju",
		job: "Business Ops Leader",
		paragraph:
			"În rolul său IT, Paul a dovedit mult mai mult decât expertiza tehnică, prin focus pe client și disponibilitate. Este un profesionist solid și un partener de încredere pentru echipa Commercial Excellence.",
		avatar: "/assets/linkedin/cristina_deju.jpg",
	},
	{
		id: 2,
		company_url: "https://stefanini.com/",
		company_name: "Stefanini EMEA",
		past_company_name: "",
		worked_with: "Dragos",
		name: "Florin Stefan",
		job: "Applications Development Director",
		paragraph: `Am lucrat cu Dragos Leonte la Stefanini în departamentul Applications Development, inițial ca Line Manager, apoi ca Applications Development Director. Dragos era un programator tânăr ambițios, dornic să învețe și să se dezvolte. Interacțiunea dintre noi a fost mereu deschisă și pozitivă. În anii de colaborare a fost dedicat, responsabil și a livrat conform așteptărilor.`,
		avatar: "/assets/linkedin/florin_stefan.jpg",
	},
	{
		id: 3,
		company_url: "https://www.aptiv.com/",
		company_name: "Aptiv",
		past_company_name: "Garrett Motion",
		worked_with: "Paul",
		name: "Cosmin Vara",
		job: "Global BPO Leader",
		paragraph:
			"Am lucrat cu Paul câțiva ani în proiecte diferite și apoi în echipa mea. Este un om special, developer IT inteligent și muncitor, dar și sensibil. Recomand pentru abilitățile tehnice și înțelegerea proceselor de business.",
		avatar: "/assets/linkedin/cosmin_vara.jpg",
	},
	{
		id: 4,
		company_url: "https://www.wehkamp.nl/",
		company_name: "Wehkamp",
		past_company_name: "NextUp",
		worked_with: "Paul",
		name: "Sergiu Ilies",
		job: "Senior Software Engineer",
		paragraph:
			"Am avut șansa să lucrez cu Paul la NextUp la software-ul lor contabil. A cerut logică complexă și abilități puternice .NET și SQL, pe care Paul le posedă. Este o persoană muncitoare, energică și motivată. Cred că ar fi un plus pentru orice organizație.",
		avatar: "/assets/linkedin/sergiu_ilies.jpg",
	},
	{
		id: 5,
		company_url: "https://www.linkedin.com/company/confidentiallosangeles/",
		company_name: "Confidential",
		past_company_name: "NextUp",
		worked_with: "Paul",
		name: "Ionut Nicolescu",
		job: "Senior Microsoft Cloud Engineer",
		paragraph: `A fost o plăcere să lucrez cu Paul – este un profesionist bun, energic și pasionat de programare. Imediat după ce l-am cunoscut am simțit conexiunea și încrederea. După doi ani, Paul este mereu gata să ajute și deschis la idei noi. Îl recomand pentru orice companie din IT.`,
		avatar: "/assets/linkedin/ionut_nicolescu.jpg",
	},
	{
		id: 6,
		company_url: "https://www.uipath.com/",
		company_name: "UiPath",
		past_company_name: "NextUp",
		worked_with: "Paul",
		name: "Ion Miron",
		job: "Principal Engineering Manager",
		paragraph: `Am lucrat cu Paul aproximativ 9 luni și am fost impresionat de automotivare și atitudine pozitivă. Abilitățile de programare l-au făcut rapid un activ valoros. Dedicația pentru performanță și îmbunătățire îl face să evolueze zilnic. Înțelege scopul de business și ridică întrebări relevante. Îl recomand cu încredere.`,
		avatar: "/assets/linkedin/ion_miron.jpg",
	},
	{
		id: 7,
		company_url: "https://www.playtika.com/",
		company_name: "Playtika",
		past_company_name: "SETRIO",
		worked_with: "Paul",
		name: "Ionut Frunza",
		job: "Senior Software Developer",
		paragraph:
			"Paul este cea mai muncitoare persoană pe care am cunoscut-o. În anul în care am lucrat împreună și-a îmbunătățit abilitățile de programare foarte rapid. Este de încredere, răspunde rapid la taskuri și este plăcut.",
		avatar: "/assets/linkedin/ionut_frunza.jpg",
	},
	{
		id: 8,
		company_url: "https://www.allianztiriac.ro/",
		company_name: "Allianz-Tiriac Asigurari",
		past_company_name: "SETRIO",
		worked_with: "Paul",
		name: "Corina Mutu",
		job: "IT Strategy & Project Manager",
		paragraph: `L-am cunoscut pe Paul în septembrie 2013 și am lucrat în aceeași echipă de atunci. Paul a dovedit mereu că este capabil, dornic să lucreze mai mult și să-și dezvolte rapid abilitățile. Este plăcut și abordează sarcinile cu entuziasm. Lucrează eficient cu colegii. Îl recomand pentru orice echipă.`,
		avatar: "/assets/linkedin/corina_mutu.jpg",
	},
	{
		id: 9,
		company_url: "https://www.microsoft.com/",
		company_name: "Microsoft",
		past_company_name: "Dell Technologies",
		worked_with: "Dragos",
		name: "Gabriel Oprea",
		job: "Senior Software Engineer",
		paragraph: `Am lucrat cu Dragos la Dell în prima echipă locală pentru programul „Lease Transformation” – 1 Scrum Master, 1 PM și 7 developeri. Am construit aplicații de integrare între aplicațiile Dell și noua platformă de leasing. Am dezbătut cele mai bune abordări pentru fiecare aplicație și arhitectura de microservicii. Colaborarea cu Dragos a fost excelentă, deschis la sugestii și pasionat de tehnologii și procese noi.`,
		avatar: "/assets/linkedin/gabriel_oprea.jpg",
	},
];
